export const FETCHING_MERCHANT_PAYMENT_DATA_BEGINS =
  "FETCHING_MERCHANT_PAYMENT_DATA_BEGINS";

  export const FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS =
  "FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS";

export const FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS =
  "FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS";
export const FETCHING_MERCHANT_PAYMENT_DATA_FAILURE =
  "FETCHING_MERCHANT_PAYMENT_DATA_FAILURE";
export const FETCHING_CONVENIENCE_DATA_SUCCESS = "FETCHING_CONVENIENCE_DATA_SUCCESS";
export const FETCHING_GLOBAL_BIN_DATA_SUCCESS = "FETCHING_GLOBAL_BIN_DATA_SUCCESS";
export const FETCHING_CHECK_ELIGIBILITY_FOR_CARDLESS_EMI = "FETCHING_CHECK_ELIGIBILITY_FOR_CARDLESS_EMI";
export const CLEAR_CHECK_ELIGIBILITY_FOR_CARDLESS_EMI = "CLEAR_CHECK_ELIGIBILITY_FOR_CARDLESS_EMI";
export const RESEND_OTP = "RESEND_OTP";
export const CLEAR_RESEND_OTP = "CLEAR_RESEND_OTP";
export const SET_SELECTED_EMI_DATA = "SET_SELECTED_EMI_DATA";
export const SET_EMI_TYPE_ID = "SET_EMI_TYPE_ID";
export const SET_CARD_TYPE_ID = "SET_CARD_TYPE_ID";
export const SET_ISSUER_ID = "SET_ISSUER_ID";
export const SET_TENURE_ID = "SET_TENURE_ID";
export const SET_CHOOSE_OTHER_EMI = "SET_CHOOSE_OTHER_EMI";
export const CHOOSE_EMI_PAYMENT_MODE = "CHOOSE_EMI_PAYMENT_MODE";
export const SET_PAYMENT_AMOUNT = "SET_PAYMENT_AMOUNT";
export const SET_PAYMENT_FEE = "SET_PAYMENT_FEE";
export const SET_PAYMENT_TOTAL = "SET_PAYMENT_TOTAL";
export const UPI_OPTION_SELECTED = "UPI_OPTION_SELECTED";
export const NBFC_OPTION_SELECTED = "NBFC_OPTION_SELECTED";
export const NBFC_PAYMENT_OTP_GENERATED = "NBFC_PAYMENT_OTP_GENERATED"
export const NBFC_PAYMENT_OTP_SUBMITTED = "NBFC_PAYMENT_OTP_SUBMITTED"
export const NBFC_TRANSACTION_ERROR_OCCURED = "NBFC_TRANSACTION_ERROR_OCCURED"
export const FETCHING_DATA_SUCCESS = "FETCHING_DATA_SUCCESS";
export const SET_PAYMENT_MODE_ID = "SET_PAYMENT_MODE_ID";
export const SET_CONVENIENCE_PAYMENT_MODE_ID = "SET_CONVENIENCE_PAYMENT_MODE_ID";
export const SET_CONVENIENCE_CARD_NETWORK_TYPE = "SET_CONVENIENCE_CARD_NETWORK_TYPE";
export const SET_CONVENIENCE_FEE_FOR_SELECTED_MODE = "SET_CONVENIENCE_FEE_FOR_SELECTED_MODE";
export const SET_REMOVED_SEQUENCE_ID = "SET_REMOVED_SEQUENCE_ID";
export const SESSION_EXPIRES = "SESSION_EXPIRES";
export const CONFIG_FETCHED_BHARAT_QR_CODE_GENERATED_VIEW = "CONFIG_FETCHED_BHARAT_QR_CODE_GENERATED_VIEW";
export const BHARAT_QR_TIMER_VIEW_RENDERED = "BHARAT_QR_TIMER_VIEW_RENDERED";
export const UPI_TIMER_VIEW_CONFIG_FETCHED = "UPI_TIMER_VIEW_CONFIG_FETCHED";
export const SET_NO_CASHBACK_FULL_PAYMENT_MODE_SELECTED = "SET_NO_CASHBACK_FULL_PAYMENT_MODE_SELECTED";
export const SET_UPI_INTENT_DATA = "SET_UPI_INTENT_DATA";
export const SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED = "SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED";
